<template>
  <span
    class="badge"
    :class="{
      'bg-info': status === 1,
      'bg-warning': status === 2,
      'bg-danger': status === 3,
    }"
  >
    {{ label }}
  </span>
</template>

<script>
import { i18n } from "@/i18n";

export default {
  name: "AlertStatusComponent",
  props: {
    status: {
      type: Number,
      required: true,
    },
  },
  computed: {
    label() {
      switch (this.status) {
        case 1:
          return i18n.global.t("registration.alert.level.info");
        case 2:
          return i18n.global.t("registration.alert.level.warning");
        case 3:
          return i18n.global.t("registration.alert.level.error");
      }
      return "";
    },
  },
};
</script>

<style lang="scss" scoped></style>
